const middleware = {}

middleware['authentication'] = require('../middleware/authentication.js')
middleware['authentication'] = middleware['authentication'].default || middleware['authentication']

middleware['hasClass'] = require('../middleware/hasClass.js')
middleware['hasClass'] = middleware['hasClass'].default || middleware['hasClass']

middleware['pendingPayment'] = require('../middleware/pendingPayment.js')
middleware['pendingPayment'] = middleware['pendingPayment'].default || middleware['pendingPayment']

middleware['user'] = require('../middleware/user.js')
middleware['user'] = middleware['user'].default || middleware['user']

export default middleware
